import script from "./imageViewerModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./imageViewerModal.vue?vue&type=script&setup=true&lang=ts"

import "./imageViewerModal.vue?vue&type=style&index=0&id=a9af2b72&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9af2b72"]])

export default __exports__